import { render } from "./toppage.vue?vue&type=template&id=72fd20da&scoped=true"
import script from "./toppage.vue?vue&type=script&lang=js"
export * from "./toppage.vue?vue&type=script&lang=js"

import "./toppage.vue?vue&type=style&index=0&id=72fd20da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fd20da"]])

export default __exports__